module.exports = __webpack_public_path__ + "static/img/rpacj1.803ee7e0.png";